/**
 * Created by andrey on 24.12.2020.
 */

const FogsConfig = {};

FogsConfig.initialize = function () {
    FogsConfig.afterInitialize();
};

FogsConfig.afterInitialize = function () {
    FogsConfig.codes = Object.keys(FogsConfig).filter((code) => typeof FogsConfig[code] === "object" && ["codes", "ads"].indexOf(code) === -1);

    if (!cleverapps.config.debugMode) {
        return;
    }

    FogsConfig.codes.forEach((code) => {
        const config = FogsConfig[code];

        const ids = {};
        for (const key in config) {
            const fog = config[key];

            let error;

            if (typeof fog.id !== "number") {
                error = `Fog need id for sync - ${key}`;
            } else if (fog.id >= Fogs.SYNCED_BITS) {
                error = `Fog id ${fog.id} is big`;
            } else if (ids[fog.id]) {
                error = `Not unique fog id - ${fog.id}`;
            }

            if (error) {
                throw error;
            }
            ids[fog.id] = true;
        }
    });
};

FogsConfig.GetFog = function (locationId) {
    const locationMeta = cleverapps.meta.getLocationMeta(locationId);
    const bundle = bundles[locationMeta.locationConfig.locationBundleId];

    const config = bundle && bundle.jsons.fogs_json && bundle.jsons.fogs_json.resolve().getJson()
        || FogsConfig[locationId]
        || {};

    if (cleverapps.config.debugMode) {
        const used = new Set();

        Object.keys(config).forEach((fogId) => {
            const data = config[fogId];

            if (data.id === undefined) {
                throw new Error(`no id for fog ${fogId} in ${locationId}`);
            }

            if (used.has(data.id)) {
                throw new Error(`duplicated id ${data.id} for fog ${fogId} in ${locationId}`);
            }

            used.add(data.id);
        });
    }

    return config;
};

if (typeof cc === "undefined") {
    module.exports = FogsConfig;
}
